import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'adunitCallout.label',
    defaultMessage: 'Update adunit name',
  },
});
